import NavBar from '../components/NavBar'
import HeroSection from '../components/DeploymentConfiguration/HeroSection'
import Footer from '../components/Footer'
import ProcessSection from '../components/DeploymentConfiguration/ProcessSection'
import TechStackMarquee from '../components/DeploymentConfiguration/TechStackMarquee'
import ContactMap from '../components/ContactMap'

const DeploymentConfiguration = () => {
	return (
		<div className="min-h-screen">
			<NavBar />
			<HeroSection />
			<ProcessSection />
			<TechStackMarquee />
			<ContactMap />
			<Footer />
		</div>
	)
}

export default DeploymentConfiguration